// Lista completa con 'name' exactamente igual al campo 'description'
export const casesActivityMock = [
    { value: 'Administración de fincas', name: 'Administración de fincas' },
    { value: 'Asesoramiento jurídico', name: 'Asesoramiento jurídico' },
    { value: 'Asesoría fiscal contable', name: 'Asesoría fiscal contable' },
    { value: 'Asesoría fiscal y laboral', name: 'Asesoría fiscal y laboral' },
    { value: 'Asesoría fiscal, laboral y jurídica', name: 'Asesoría fiscal, laboral y jurídica' },
    { value: 'Asesoría laboral', name: 'Asesoría laboral' },
    { value: 'Auditoría', name: 'Auditoría' },
    { value: 'Auditoría financiera y contable', name: 'Auditoría financiera y contable' },
    { value: 'Backup', name: 'Backup' },
    { value: 'Colegio oficial', name: 'Colegio oficial' },
    { value: 'Control de acceso de las instalaciones', name: 'Control de acceso de las instalaciones' },
    { value: 'Control de plagas', name: 'Control de plagas' },
    { value: 'Custodia de documentación', name: 'Custodia de documentación' },
    { value: 'Destrucción de soportes y documentación', name: 'Destrucción de soportes y documentación' },
    { value: 'Empresa de software de gestión laboral', name: 'Empresa de software de gestión laboral' },
    { value: 'Empresa de trabajo temporal', name: 'Empresa de trabajo temporal' },
    { value: 'Expendedoras de agua', name: 'Expendedoras de agua' },
    { value: 'Gremio sectorial', name: 'Gremio sectorial' },
    { value: 'Instalación de sistemas de seguridad sin Videovigilancia', name: 'Instalación de sistemas de seguridad sin Videovigilancia' },
    { value: 'Instalación de sistemas de Videovigilancia', name: 'Instalación de sistemas de Videovigilancia' },
    { value: 'Limpieza', name: 'Limpieza' },
    { value: 'Mantenimiento de extintores', name: 'Mantenimiento de extintores' },
    { value: 'Mantenimiento de hardware', name: 'Mantenimiento de hardware' },
    { value: 'Mantenimiento de impresoras, escaners o fotocopiadoras', name: 'Mantenimiento de impresoras, escaners o fotocopiadoras' },
    { value: 'Mantenimiento de instalaciones', name: 'Mantenimiento de instalaciones' },
    { value: 'Mantenimiento de software', name: 'Mantenimiento de software' },
    { value: 'Mantenimiento de software y hardware', name: 'Mantenimiento de software y hardware' },
    { value: 'Mantenimiento de software, hardware y web', name: 'Mantenimiento de software, hardware y web' },
    { value: 'Mantenimiento web', name: 'Mantenimiento web' },
    {
        value: 'Marketing y envío de mailing masivo y Community manager y posicionamiento web',
        name: 'Marketing y envío de mailing masivo y Community manager y posicionamiento web',
    },
    { value: 'Material Administrativo / oficina', name: 'Material Administrativo / oficina' },
    { value: 'Otros', name: 'Otros' },
    { value: 'Prevención de riesgos laborales', name: 'Prevención de riesgos laborales' },
    { value: 'Publicidad', name: 'Publicidad' },
    { value: 'Seguridad', name: 'Seguridad' },
    { value: 'Selección de personal', name: 'Selección de personal' },
    { value: 'Servicios de Catering', name: 'Servicios de Catering' },
    { value: 'Servicios de cloud computing', name: 'Servicios de cloud computing' },
    { value: 'Servicios de consultoría', name: 'Servicios de consultoría' },
    { value: 'Servicios de hosting', name: 'Servicios de hosting' },
    { value: 'Servicios de impresión', name: 'Servicios de impresión' },
    { value: 'Servicios de mensajería', name: 'Servicios de mensajería' },
    { value: 'Servicios de outsourcing', name: 'Servicios de outsourcing' },
    { value: 'Servicios de traducción e Imprenta', name: 'Servicios de traducción e Imprenta' },
    { value: 'Transporte', name: 'Transporte' },
    { value: 'Trastero', name: 'Trastero' },
    { value: 'Vigilancia de la salud', name: 'Vigilancia de la salud' },
];
